import React, { useState, useRef, useEffect } from 'react';
import { GoogleMap, LoadScript, Polyline, Marker, Circle } from '@react-google-maps/api';
import Papa, { parse } from 'papaparse';
import { storage, firestore } from '../../helpers/firebaseConfig'; // Your Firebase configuration
import { ref, getDownloadURL } from 'firebase/storage';
import BlockedRoadIcon from '../../assets/images/blockedroad_icon.png';
import ContraflowIcon from '../../assets/images/contraflow.png';
import { collection, getDocs, doc, getDoc, setDoc, updateDoc, arrayUnion } from 'firebase/firestore';
import { formatTime } from '../../helpers/generalHelpers';
import { geocodeAddress } from '../../helpers/AI_functions';
import SafetyIcon from '../../assets/images/safety_icon.png'
import ColourBar from "./ColourBar"
import { Timestamp } from "firebase/firestore";


const containerStyle = {
  width: '100%',
  height: '740px',
  borderRadius: '0px',
  overflow: 'hidden',
  marginBottom: '20px'
};

const darkMapStyle = [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
   {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#223322" }] // Use a dark green color
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#38414e" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#212a37" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#746855" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#1f2835" }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#f3d19c" }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#2f3948" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#17263c" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#515c6d" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#17263c" }],
  },
];


const DEFAULT_CENTER = { lat: 37.721941, lng: -122.127001 };   // already have “center”; keep a copy
const DEFAULT_ZOOM   = 14.8;                                   // whatever your initial zoom is

// Coordinates for blocked roads and contraflow
const blockedRoadPositions = [
    { lat: 37.902543, lng: -122.266140 },
    { lat: 37.899952, lng: -122.261140 },
    { lat: 37.896049, lng: -122.259348 },
  ];


const contraflowPosition = { lat: 37.892949, lng: -122.268037 };
const destinationNodes = [
  { nodeId: 43, numberOfAgents: 10 },
  { nodeId: 151, numberOfAgents: 10 },
  { nodeId: 171, numberOfAgents: 10 },
  { nodeId: 187, numberOfAgents: 10 },
  { nodeId: 188, numberOfAgents: 10 },
  { nodeId: 191, numberOfAgents: 10 },
  { nodeId: 195, numberOfAgents: 10 },
  { nodeId: 199, numberOfAgents: 10 },
];

const mbStorageBase = (simulationId) => `model_builders/${simulationId}`;

function ModelBuilderMapComponent({state, updateState}) {
  const { contraflow, blockedRoads, time, dynamic_data, ticketStatuses, focusTicket, tickets = [] } = state; // Destructure the state object  
  const GOOGLE_MAPS_API_KEY = 'AIzaSyASU8wb6swDIo3dNxkyjfraWijCImc3-OU';
  const [polylines, setPolylines] = useState([]);

  const otherTickets = tickets.filter(t => t.id?.startsWith('other_'));

  const [isLoading, setIsLoading] = useState(false);
  // const [time, setTime] = useState(1300); // Default time is 1300
  const [simulations, setSimulations] = useState([]); // State to hold simulation list
  const [selectedSimulation, setSelectedSimulation] = useState({'id':'simulation_1', 'name': 'Bay O Vista', 'total_time':0}); // Default to Baseline
  const [contraflowCenters, setContraflowCenters] = useState([]);
  const [linkMap, setLinkMap] = useState({});
  const [nodeMap, setNodeMap] = useState({});
  const [showPolyLines, setShowPolyLines] = useState(true); // Toggle state

  const [showAllNodes, setShowAllNodes] = useState(false);  
  const [showAllLinks, setShowAllLinks] = useState(true);
  const [showParcels,     setShowParcels]     = useState(true);   // default ON

  const [selectedLinkIds, setSelectedLinkIds] = useState(new Set());
  const [selectedNodeIds, setSelectedNodeIds] = useState(new Set());

  const [selectedOtherId, setSelectedOtherId] = useState(null);

  const [selectedLinkId, setSelectedLinkId] = useState(null);   // single-select link
  const [showCommentBox, setShowCommentBox] = useState(false);
  const [commentText, setCommentText]     = useState("");

  const [populationMap,   setPopulationMap]   = useState({});     // parcel_id → {lat,lng,pop,…}
  const [selectedParcelId, setSelectedParcelId] = useState(null);

  const [locationInput, setLocationInput] = useState("");

  const mapRef = useRef(null); // Ref to access the map instance
  const polylinesRef = useRef([]); // Ref to keep track of Polyline instances
  const dynamicPolylinesRef = useRef([]) //Ref for dynamic polyline instances
  const dynamicNodesRef = useRef([]) 
  

  const [linkScale, setLinkScale] = useState(null);   // { ranges:[{color,start,end}], min, max }
  const [nodeScale, setNodeScale] = useState(null);



  function computeScales(data, type) {
    const items   = data.filter(d => d.Type === type);
    if (!items.length) return null;
  
    // group by colour → record the highest value per colour
    const colourMax = {};
    items.forEach(({ Color, Value }) => {
      const v = Number(Value);
      colourMax[Color] = Math.max(colourMax[Color] ?? -Infinity, v);
    });
  
    // sort colours by their “max” so low‑value colours come first
    const sorted = Object.entries(colourMax)
      .sort((a, b) => a[1] - b[1]);          // [ [colour, max], … ]
  
    const min  = Math.min(...items.map(i => +i.Value));
    const max  = Math.max(...items.map(i => +i.Value));
  
    let start  = min;
    const ranges = sorted.map(([color, colMax], i) => {
      const r = { color, start, end: colMax };
      start   = colMax;                      // next segment starts where this ends
      if (i === sorted.length - 1) r.end = max;
      return r;
    });
  
    return { ranges, min, max };
  }

  function colourForValue(v, scale) {
    if (!scale) return '#FFFFFF';            // fallback; shouldn't normally hit
    return scale.ranges.find(r => v >= r.start && v <= r.end)?.color
           ?? scale.ranges[scale.ranges.length - 1].color;
  }


  const togglePolylines = () => {

    if(showPolyLines)  //Toggled from true to false
    {
      //Set polyLine as empty
      clearAndSetPolylines([])
      updateDynamicLinkData();
    }
    else{
      clearAndSetDynamicPolylines([])
      clearAndSetDynamicNodes([])
    }
    setShowPolyLines((prev) => !prev);
  };

  const arrowSymbol = (color, size = 2.5) => [{
    icon: {
      path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      scale: size,
      strokeColor: color,
      strokeOpacity: 1,
      fillOpacity: 1
    },
    offset: '100%'          // centre of the last segment
  }];

  const clearAndSetPolylines = (parsedPolylines) => {

    const map = mapRef.current; 

    console.log("Normal polylines: ", parsedPolylines)

    // Step 1: Remove all existing polylines from the map
    polylinesRef.current.forEach((polylineInstance) => {
      if (polylineInstance) {
        polylineInstance.setMap(null); // Remove polyline from the map
      }
    });
  
    // Step 2: Clear the current polyline references
    polylinesRef.current = [];

    // console.log(parsedPolylines)

    

    // Step 3: Add new polylines to the map
    parsedPolylines.forEach((polylineData) => {
      const clr = getColorBasedOnQueue(polylineData.queue_vehicle_count);
      const polyline = new window.google.maps.Polyline({
        path: polylineData.path, // Array of LatLng objects
        strokeColor: getColorBasedOnQueue(polylineData.queue_vehicle_count), // Define color based on queue
        strokeOpacity: 0.75,
        strokeWeight: selectedLinkIds.has(polylineData.link_id) ? 11 : 4,
        key: 'link-'+polylineData.link_id,
        icons: arrowSymbol(clr)
      });

      // Add onClick listener to each polyline
      polyline.addListener("click", () => {
        // Handle click event for polyline (programmatically or interactively)
        console.log(`Polyline with linkId ${polylineData.link_id} clicked`);

        // Example: Add the polyline's ID to the selection set
        handlePolylineClick(polylineData.link_id); // You can call your `handlePolylineClick` function here
      });
  
      // Set the polyline on the map
      polyline.setMap(map);
  
      // Add the new polyline instance to the ref
      polylinesRef.current.push(polyline);
    });
  
    console.log("Removed old polylines and added new ones");
  };

  const handlePolylineClick = (linkId) => {

    console.log("Clicked on Link: ", linkId)
    setSelectedLinkId(prev => (prev === linkId ? null : linkId));
    setSelectedParcelId(null);
    setSelectedOtherId(null);
    setShowCommentBox(false);          // close any open comment box

    const map = mapRef.current;
    const mid = linkCenter(linkMap[linkId].path);
    zoomTo(map, mid,17); 

  };

  const handleParcelClick = (pid) => {
    setSelectedParcelId(prev => (prev === pid ? null : pid));
    setSelectedLinkId(null);
    setSelectedOtherId(null);
    setShowCommentBox(false);

    const map = mapRef.current;
    const p   = populationMap[pid];
    if (p) zoomTo(map, { lat: p.lat, lng: p.lng }, 18);
  };

  const handleNodeClick = (nodeId) => {

    console.log("Clicked on Node: ", nodeId)
    let newSelectedNodeIds = selectedNodeIds;
    if (newSelectedNodeIds.has(nodeId)) {
      newSelectedNodeIds.delete(nodeId); // Deselect the polyline if it's already selected
    } else {
      newSelectedNodeIds.add(nodeId); // Select the polyline
    }
    console.log("New selected links", newSelectedNodeIds)
    setSelectedNodeIdsWrapper(newSelectedNodeIds);
  };


  const clearAndSetDynamicNodes = (parsedNodes) => {

    const map = mapRef.current; 

    // Step 1: Remove all existing polylines from the map
    dynamicNodesRef.current.forEach((nodeInstance) => {
      if (nodeInstance) {
        nodeInstance.setMap(null); // Remove polyline from the map
      }
    });
  
    // Step 2: Clear the current polyline references
    dynamicNodesRef.current = [];

    // console.log(parsedPolylines)  

    console.log("Here111: ", selectedNodeIds)
 
    // Step 3: Add new polylines to the map
    parsedNodes.map((nodeData) => {
      const circle = new window.google.maps.Circle({
          key: 'node-'+String(nodeData.id),
          center: { lat: nodeData.lat, lng: nodeData.lng },
          radius: selectedNodeIds.has(String(nodeData.id))? 36: 16,
          fillColor: nodeData.color,
          fillOpacity: selectedNodeIds.has(String(nodeData.id))? 1: 0.7,
          strokeColor: "black",
          strokeOpacity: 1,
          strokeWeight: 2,
          map: map // Attach to the map
      });

      circle.addListener("click", () => {
        // Handle click event for polyline (programmatically or interactively)
        console.log(`Node with nodeId ${nodeData.id} clicked`);

        // Example: Add the polyline's ID to the selection set
        handleNodeClick(String(nodeData.id)); // You can call your `handlePolylineClick` function here
      });
       
      // Set the polyline on the map
      circle.setMap(map);
  
      // Add the new polyline instance to the ref
      dynamicNodesRef.current.push(circle);
    });
  
    console.log("Removed old dynamic nodes and added new ones");
  };


  const clearAndSetDynamicPolylines = (parsedPolylines) => {

    const map = mapRef.current; 

    // Step 1: Remove all existing polylines from the map
    dynamicPolylinesRef.current.forEach((polylineInstance) => {
      if (polylineInstance) {
        polylineInstance.setMap(null); // Remove polyline from the map
      }
    });
  
    // Step 2: Clear the current polyline references
    dynamicPolylinesRef.current = [];

    console.log("Dynamic polylines", parsedPolylines)

 
    // Step 3: Add new polylines to the map
    parsedPolylines.forEach((polylineData) => {
      const polyline = new window.google.maps.Polyline({
        path: polylineData.coordinates, // Array of LatLng objects
        strokeColor: polylineData.color, // Define color based on queue
        strokeOpacity: 0.75,
        strokeWeight: selectedLinkIds.has(String(polylineData.id)) ? 11 : 4,
        key: 'link-'+polylineData.id
      });

      polyline.addListener("click", () => {
        // Handle click event for polyline (programmatically or interactively)
        console.log(`Polyline with linkId ${polylineData.id} clicked`);

        // Example: Add the polyline's ID to the selection set
        handlePolylineClick(String(polylineData.id)); // You can call your `handlePolylineClick` function here
      });
  
      // Set the polyline on the map
      polyline.setMap(map);
  
      // Add the new polyline instance to the ref
      dynamicPolylinesRef.current.push(polyline);
    });
  
    console.log("Removed old dynamic polylines and added new ones");
  };


  // Fetch simulation data from Firebase Storage using Firebase SDK
  const fetchSimulationData = async (time, contraflowEnabled, simulationId) => {
    try {

      const filePath = `${mbStorageBase(simulationId)}/link_stats/lbase-tester_at_${time}.csv`;
      const fileRef = ref(storage, filePath); // Get reference to the file
      
      // Get the download URL for the file
      const url = await getDownloadURL(fileRef);
      // console.log(url)

      // Fetch CSV content from the URL
      const response = await fetch(url);
      const csvText = await response.text();
    
      // Parse CSV and process data
      Papa.parse(csvText, {
        header: true,
        complete: (results) => {
          const data = results.data;
          // console.log(data)
          const parsedPolylines = data.map((row) => {
            if (row.geometry) {
              const path = row.geometry
                .replace('LINESTRING (', '')
                .replace(')', '')
                .split(', ')
                .map((point) => {
                  const [lng, lat] = point.split(' ').map(Number);
                  return { lat, lng };
                });
              return {
                path,
                queue_vehicle_count: parseInt(row.queue_vehicle_count, 10),
                link_id: row.link_id
              };
            }
            return null;
          }).filter(Boolean);
          console.log("polylines: ", parsedPolylines)
          clearAndSetPolylines(parsedPolylines)
          // setPolylines(parsedPolylines);
          setIsLoading(false);
        },
      });
    } catch (error) {
      console.error('Error fetching or parsing CSV:', error);
      setPolylines([]);
      setIsLoading(false);
    }
  };

  const updateDynamicLinkData = async () => {
    if (!dynamic_data || !dynamic_data.length) return;
  
    const newPolylines = [];
    const newNodes     = [];
  
    dynamic_data.forEach(({ id, Value, Type }) => {
      const colour = colourForValue(Number(Value),
                       Type === 'link' ? linkScale : nodeScale);
  
      if (Type === 'link') {
        const linkInfo = linkMap[String(id)];
        if (linkInfo?.geometry) {
          newPolylines.push({
            id,
            coordinates: parseLineString(linkInfo.geometry),
            color: colour
          });
        }
      } else if (Type === 'node') {
        const nodeInfo = nodeMap[String(id)];
        if (nodeInfo?.lat && nodeInfo?.lng) {
          newNodes.push({
            id,
            lat: nodeInfo.lat,
            lng: nodeInfo.lng,
            color: colour
          });
        }
      }
    });
  
    clearAndSetDynamicPolylines(newPolylines);
    clearAndSetDynamicNodes(newNodes);
  }


  // Function to parse LINESTRING into an array of [lat, lng] coordinates
  function parseLineString(lineString) {
    const coords = lineString
      .replace("LINESTRING (", "")
      .replace(")", "")
      .split(", ")
      .map((point) => {
        const [lng, lat] = point.split(" ").map(Number); // Convert to numbers
        return {lat, lng}; // Leaflet requires [lat, lng]
      });
    return coords;
  }

  const fetchPopulationData = async (simulationId) => {
        try {
        const filePath = `${mbStorageBase(simulationId)}/inputs/berkeley_parcels.csv`;
        // console.log("pop_filepath", filePath)
        const url      = await getDownloadURL(ref(storage, filePath));
        const csv      = await (await fetch(url)).text();

        // console.log("pop_csv", csv)
    
        const popMap = {};
        Papa.parse(csv, {
            header: true,
            skipEmptyLines: true,
            complete: ({ data }) => {
            data.forEach(r => {
                if (r.parcel_id && r.lat && r.lon)
                popMap[r.parcel_id] = {
                    lat:  +r.lat,
                    lng:  +r.lon,
                    pop:  +r.pop,
                    street: r.SITE_STREE,
                    city:   r.SITE_CITY,
                    state:  r.SITE_STATE,
                    zip:    r.SITE_ZIP
                };
            });
             console.log("popmap", popMap)
            setPopulationMap(popMap);
            }
        });
        } catch (err) { console.error('Error fetching parcels:', err); }
    };


  const fetchNodeData = async (simulationId) => {
    try {
        const filePath = `${mbStorageBase(simulationId)}/inputs/berkeley_nodes.csv`; // Adjust if stored in a folder
        const fileRef = ref(storage, filePath);
        const url = await getDownloadURL(fileRef);

        const response = await fetch(url);
        const csvText = await response.text();

        const nodeMapTemp = {}; // Temporary object to store nodes

        Papa.parse(csvText, {
            header: true, // First row is treated as headers
            skipEmptyLines: true,
            complete: (result) => {
                result.data.forEach((row) => {
                    if (row.node_id && row.lat && row.lon) {
                        nodeMapTemp[row.node_id] = {
                            lat: parseFloat(row.lat),
                            lng: parseFloat(row.lon),
                            type: row.type,
                            osmid: row.node_osmid
                        };
                    }
                });

                console.log("Parsed Node Map:", nodeMapTemp); // Debugging
                setNodeMap(nodeMapTemp); // Store in state
            }
        });

    } catch (error) {
        console.error("Error fetching node data:", error);
    }
};

  const fetchLinkData = async (simulationId) => {
    try {
      const filePath = `${mbStorageBase(simulationId)}/inputs/berkeley_links.csv`; // Adjust if stored in a folder
      const fileRef = ref(storage, filePath);
      const url = await getDownloadURL(fileRef);

      const response = await fetch(url);
      const csvText = await response.text();

      Papa.parse(csvText, {
        header: true,
        complete: (results) => {
          const data = results.data;
          const linkMapTemp = {};

          data.forEach((row) => {
            if (row.link_id && row.geometry) {
              const path = row.geometry
                .replace('LINESTRING (', '')
                .replace(')', '')
                .split(', ')
                .map((point) => {
                  const [lng, lat] = point.split(' ').map(Number);
                  return { lat, lng };
                });

              linkMapTemp[row.link_id] = { path, ...row };
            }
          });

          // console.log(linkMapTemp)
          setLinkMap(linkMapTemp);
        },
      });
    } catch (error) {
      console.error('Error fetching or parsing CSV:', error);
    }
  };
  

  // Fetch contraflow links data from Firebase Storage
const fetchContraflowLinks = async (simulationId) => {
    try {
      const filePath = `${mbStorageBase(simulationId)}/inputs/contraflow_links.csv`; // Path to the contraflow links file
      const fileRef = ref(storage, filePath); // Get reference to the file
      
      // Get the download URL for the file
      const url = await getDownloadURL(fileRef);
  
      // Fetch CSV content from the URL
      const response = await fetch(url);
      const csvText = await response.text();
      
      // Parse CSV and log the data
      Papa.parse(csvText, {
        header: true,
        complete: (results) => {
          const contraflowLinks = results.data;
          console.log("Contraflow Links:", contraflowLinks); // Console log the parsed contraflow links

          // Calculate the center for each contraflow link
        const centers = contraflowLinks.map((link) => {
            if (link.geometry) {
              // Parse the geometry field to extract coordinates
              const coordinates = link.geometry
                .replace('LINESTRING (', '')
                .replace(')', '')
                .split(', ')
                .map((point) => {
                  const [lng, lat] = point.split(' ').map(Number);
                  return { lat, lng };
                });
              
              // Calculate the center by averaging the coordinates
              const center = coordinates.reduce((acc, curr) => {
                acc.lat += curr.lat;
                acc.lng += curr.lng;
                return acc;
              }, { lat: 0, lng: 0 });
  
              center.lat /= coordinates.length;
              center.lng /= coordinates.length;
              return center;
            }
            return null;
          }).filter(Boolean);

          // Deduplicate the centers array based on lat,lng
        const uniqueCenters = Array.from(
            new Set(centers.map(a => `${a.lat},${a.lng}`)) // Create a set of unique "lat,lng" strings
          ).map(e => {
            const [lat, lng] = e.split(','); // Split back into lat, lng
            return { lat: parseFloat(lat), lng: parseFloat(lng) }; // Return an object with lat and lng
          });

          console.log(uniqueCenters)

          setContraflowCenters(uniqueCenters)
        },
      });
    } catch (error) {
      console.error('Error fetching or parsing contraflow links CSV:', error);
      setContraflowCenters([])
    }
  };

  // Fetch simulations from Firestore
  const fetchSimulations = async () => {
    try {
      const simulationsCollection = collection(firestore, 'model_builders');
      const simulationDocs = await getDocs(simulationsCollection);
      const simulationsList = simulationDocs.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // console.log(simulationsList)
      setSimulations(simulationsList);
    } catch (error) {
      console.error('Error fetching simulations:', error);
    }
  };

  // Determine polyline color based on queue_vehicle_count
  const getColorBasedOnQueue = (queueCount) => {
    if (queueCount > 10) return '#FF0000'; // Red for heavy traffic
    if (queueCount > 5) return '#FFA500'; // Orange for moderate traffic
    return '#00FF00'; // Green for light traffic
  };

  // Handle Simulation Change
  const handleSimulationChange = (event) => {
    const selectedSim = simulations.find((sim) => sim.name === event.target.value);
    // console.log(selectedSim)
    setSelectedSimulation(selectedSim);
    setIsLoading(true);
    fetchSimulationData(time, contraflow, selectedSim.id);
  };

  const saveTicket = async (type, recId, latLng, comment = null, status = "commented") => {
    
    let address = "";
    if (type === "parcel" && populationMap[recId]) {
        const p = populationMap[recId];
        address = `${p.street}, ${p.city}, ${p.state} ${p.zip}`;
    } else if (type === "link" && linkMap[recId]) {
        address = linkMap[recId].name || `Road link ${recId}`;
    }
    
    const ticketId  = `${type}_${recId}`;
    const ticketRef = doc(
        firestore,
        "simulations",
        selectedSimulation.id,   // current simulation id
        "model_tickets",
        ticketId
      );
    const snap      = await getDoc(ticketRef);

  
    if (snap.exists()) {
      // append comment and/or update status
      const updates = {};
      if (comment) updates.comments_array = arrayUnion(comment);
      updates.status = status;
      await updateDoc(ticketRef, updates);
    } else {
      await setDoc(ticketRef, {
        id: ticketId,
        latitude:  latLng.lat,
        longitude: latLng.lng,
        comments_array: comment ? [comment] : [],
        status,
        address
      });
    }
  };

  const handleSaveComment = async (kind) => {
    /** create the { text , ts } object expected by Firestore */
    const text = commentText.trim();
    if (!text) {                        // nothing to save
      setShowCommentBox(false);
      return;
    }
    const comment = {
      text,
      ts: Timestamp.now().toMillis()
    };
  
    try {
      if (kind === "link" && selectedLinkId) {
        const mid = linkCenter(linkMap[selectedLinkId].path);            // link midpoint
        await saveTicket(
          "link",
          selectedLinkId,
          mid,                       // { lat , lng }
          comment,                   // << send comment object, not raw string
          "commented"
        );
        setSelectedLinkId(null);
      } else if (kind === "parcel" && selectedParcelId) {
        const p = populationMap[selectedParcelId];
        await saveTicket(
          "parcel",
          selectedParcelId,
          { lat: p.lat, lng: p.lng },
          comment,
          "commented"
        );
        setSelectedParcelId(null);
      }
    } finally {
      setCommentText("");
      setShowCommentBox(false);
    }
  };

  const linkCenter = (path) => path[Math.floor(path.length / 2)];
  
  const handleValidated = async (kind) => {
    if (kind === "link" && selectedLinkId) {
      const mid = linkCenter(linkMap[selectedLinkId].path);
      await saveTicket("link", selectedLinkId, mid, null, "validated");
      setSelectedLinkId(null);
    }
    else if (kind === "parcel" && selectedParcelId) {
      const p = populationMap[selectedParcelId];
      await saveTicket("parcel", selectedParcelId, { lat: p.lat, lng: p.lng }, null, "validated");
      setSelectedParcelId(null);
    }
    else if (kind === "other" && selectedOtherId) {
      const ot = tickets.find(t => t.id === selectedOtherId);
      if (!ot) return;
      await saveTicket(
        "other",
        ot.id.replace(/^other_/, ''),
        { lat: ot.latitude, lng: ot.longitude },
        null,
        "validated"
      );
      setSelectedOtherId(null);
    }
  };

  useEffect(() => {
    fetchContraflowLinks(selectedSimulation.id);
    fetchLinkData(selectedSimulation.id);
    fetchNodeData(selectedSimulation.id);
    fetchPopulationData(selectedSimulation.id);
    updateState({
      maxTime: selectedSimulation.total_time,
      selectedSimulationId: selectedSimulation.id
    })
  }, [selectedSimulation])

  useEffect(() => {
    fetchSimulations();
    fetchLinkData(selectedSimulation.id);
    fetchNodeData(selectedSimulation.id);
    fetchPopulationData(selectedSimulation.id);    
  }, []);

  useEffect(() => {
    if (!dynamic_data || !dynamic_data.length) return;
  
    setLinkScale(computeScales(dynamic_data, 'link'));
    setNodeScale(computeScales(dynamic_data, 'node'));
  
  }, [dynamic_data]);

  useEffect(() => {
    if (linkScale || nodeScale) {
      updateDynamicLinkData();               // colour everything
      if (showPolyLines) togglePolylines();  // switch to AI view once
    }
  }, [linkScale, nodeScale]);

  // UseEffect to call fetchSimulationData initially on component load
  useEffect(() => {
    if(showPolyLines)
      fetchSimulationData(time, contraflow, selectedSimulation.id);
  }, [contraflow, time, showPolyLines]); // Empty dependency array ensures it runs only once on component mount

  useEffect(() => {
    if (!focusTicket) return;
    const map = mapRef.current;
    if (!map) return;
  
    const isLink = focusTicket.id.startsWith('link_');
    const recId  = focusTicket.id.replace(/^(link_|parcel_)/,'');
    const isOther = focusTicket.id.startsWith("other_");
  
    if (isLink) {
      // highlight this link
      setSelectedLinkId(recId);
      setSelectedParcelId(null);
      setSelectedOtherId(null);
  
      // pan/zoom to the link’s centre
      const mid = linkCenter(linkMap[recId].path);
      modifyMapCamera(map, mid, 18, 1000);
    }
    else if (isOther) {
      setSelectedOtherId(focusTicket.id);
      setSelectedLinkId(null);
      setSelectedParcelId(null);
      const ot = tickets.find(t => t.id === focusTicket.id);
      if (ot) {
        modifyMapCamera(
          map,
          { lat: ot.latitude, lng: ot.longitude },
          18,
          1000
        );
      }
    } 
     else {
      // highlight parcel
      setSelectedParcelId(recId);
      setSelectedLinkId(null);
      setSelectedOtherId(null);
  
      const p = populationMap[recId];
      if (p) modifyMapCamera(map, { lat: p.lat, lng: p.lng }, 18, 1000);
    }
  
    // optional: clear the flag once consumed
    // updateState({ focusTicket: null });
  }, [focusTicket]);

  const zoomTo = (map, latLng, zoom = 18) => {
    if (map) modifyMapCamera(map, latLng, zoom, 1000);   // <- you already have modifyMapCamera
  };


    // useEffect to watch selectedLinkIds changes and update polyline colors
  const setSelectedLinkIdsWrapper = (newSelectedLinkIds) => {

    setSelectedLinkIds(newSelectedLinkIds)

    updateState({selectedLinkIds: newSelectedLinkIds})



    polylinesRef.current.forEach((poly) => {
        if (!poly) return;
        const id = poly.key.replace('link-', '');
      
        const selected = newSelectedLinkIds.has(id);
        const colour   = selected ? 'orange' : poly.get('strokeColor'); // keep original
      
        poly.setOptions({
          strokeWeight: selected ? 11 : 4,
          icons: [{
            icon: {
              path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: selected ? 5 : 3,              // bigger arrow when selected
              strokeColor: colour,
              strokeOpacity: 1,
              fillOpacity: 1
            },
            offset: '100%'
          }]
        });
      });

    dynamicPolylinesRef.current.forEach((polylineInstance) => {
      if (polylineInstance) {
        const polylineLinkId = polylineInstance.key.replace('link-', ''); // Get the link_id from the key

        // Update the color if the linkId is selected
        polylineInstance.setOptions({
          strokeWeight: selectedLinkIds.has(polylineLinkId) ? 11 : 4,
        });
      }
    });
  }; 

  const setSelectedNodeIdsWrapper = (newSelectedNodeIds) => {

    setSelectedNodeIds(newSelectedNodeIds)

    updateState({selectedNodeIds: newSelectedNodeIds})

    if(dynamicNodesRef){
      dynamicNodesRef.current.forEach((nodeInstance) => {
        if (nodeInstance) {
          const NodeId = nodeInstance.key.replace('node-', ''); // Get the link_id from the key         
  
          // Update the color if the linkId is selected
          nodeInstance.setOptions({
            radius: newSelectedNodeIds.has(NodeId)? 36: 16,
            fillOpacity: newSelectedNodeIds.has(NodeId)? 1:0.7,
          });
        }
      });
    }

  }; 

  const modifyMapCamera = (map, endCenter, endZoom, duration = 1000) => {
    const startCenter = map.getCenter().toJSON();
    const startZoom   = map.getZoom();
    const frames      = Math.round((duration / 1000) * 60);     // ~60 fps
    let frame         = 0;
  
    const latDiff  = endCenter.lat - startCenter.lat;
    const lngDiff  = endCenter.lng - startCenter.lng;
    const zoomDiff = endZoom       - startZoom;
  
    const step = () => {
      frame += 1;
      const t  = frame / frames;                    // 0 → 1
      const ease = t < .5 ? 2 * t * t               // quadratic ease-in/out
                           : -1 + (4 - 2 * t) * t;
  
      map.setCenter({
        lat: startCenter.lat + latDiff  * ease,
        lng: startCenter.lng + lngDiff  * ease
      });
      map.setZoom(startZoom + zoomDiff * ease);
  
      if (frame < frames) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const randomSelect = () => {
    const hasLinks   = Object.keys(linkMap).length;
    const hasParcels = Object.keys(populationMap).length;
    if (!hasLinks && !hasParcels) return;
  
    const pickLink = hasLinks && (!hasParcels || Math.random() < 0.5);
  
    if (pickLink) {
      const ids = Object.keys(linkMap);
      const id  = ids[Math.floor(Math.random() * ids.length)];
      handlePolylineClick(id);
    } else {
      const ids = Object.keys(populationMap);
      const id  = ids[Math.floor(Math.random() * ids.length)];
      handleParcelClick(id);
    }
  };


  
  return (
      <div
        style={{
          position: 'relative',
          height: '100%',
          backgroundColor: '#2C2C2C', // A dark grey background
          color: '#CCC',              // Softer text color
          borderRadius: '8px',
          border: '1px solid #444'    // Subtle border
        }}
      >

        <div style={{padding: '10px'}}>
          {/* Controls container relative to the map view */}
         
        
          
        
          {showPolyLines && (
             <div style={{ marginBottom: '20px', display:'flex', alignItems:'center' }}>
               
            
                {/* NEW checkbox – show every node in blue */}
                <input
                  type="checkbox"
                  checked={showAllNodes}
                  onChange={() => setShowAllNodes(prev => !prev)}
                  style={{ marginLeft: '15px', marginRight: '5px' }}
                />
                <label style={{ color: '#FFF' }}>Show all nodes</label>

                <input
                  type="checkbox"
                  checked={showAllLinks}
                  onChange={() => setShowAllLinks(prev => !prev)}
                  style={{ marginLeft:'15px', marginRight:'5px' }}
                />
                <label style={{ color:'#FFF' }}>Show all links</label>

                <input
                    type="checkbox"
                    checked={showParcels}
                    onChange={() => setShowParcels(p => !p)}   // no manual cleanup
                    style={{ marginRight: '5px' }}
                    />
                <label style={{ color:'#FFF' }}>Show all parcels</label>

            </div>
          )}

        <div style={{ marginTop: '8px' }}>
            <button
                onClick={() => {
                const map = mapRef.current;
                if (map) modifyMapCamera(map, DEFAULT_CENTER, DEFAULT_ZOOM, 1000);
                }}
                style={{
                padding: '5px 10px',
                fontSize: '14px',
                cursor: 'pointer',
                borderRadius: '4px',
                backgroundColor: '#2563EB',
                color: '#FFF',
                border: '1px solid #444'
                }}
            >
                Reset location
            </button>

            <button
            onClick={randomSelect}
            style={{
                marginLeft: 10,
                padding: '5px 10px',
                fontSize: '14px',
                cursor: 'pointer',
                borderRadius: '4px',
                backgroundColor: '#2563EB',
                color: '#FFF',
                border: '1px solid #444'
            }}
            >
            Random selection
            </button>
        </div>

            {selectedLinkId && showAllLinks && (
            <div
                style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                zIndex: 3,
                background: "#2563EB",        /* blue-600 */
                color: "#FFF",
                padding: "12px 16px",
                borderRadius: "8px",
                minWidth: "260px",
                boxShadow: "0 2px 8px rgba(0,0,0,.25)"
                }}
            >
                {/* ── header row ── */}
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <strong>Road link</strong>
                <button
                    onClick={() => setSelectedLinkId(null)}
                    style={{background:"transparent", border:"none", color:"#FFF", cursor:"pointer", fontSize:"18px"}}
                    aria-label="Close"
                >
                    ✕
                </button>
                </div>

                {/* ── link details ── */}
                {linkMap[selectedLinkId] && (
                <p style={{margin:"6px 0 12px"}}>
                    {linkMap[selectedLinkId].name} <br/>
                    id: {selectedLinkId} <br/>
                    Max speed: {linkMap[selectedLinkId].maxmph} mph <br/>
                    Lanes: {linkMap[selectedLinkId].lanes}
                </p>
                )}

                {/* ── actions ── */}
                <div style={{display:"flex", gap:"8px"}}>
                <button
                    onClick={() => handleValidated("link" /* or "parcel" in the parcel card */)}
                    style={{flex:1, background:"#4ADE80", border:"none", color:"#000", padding:"6px 0", borderRadius:"4px", cursor:"pointer"}}
                >
                    Looks good
                </button>
                <button
                    onClick={() => setShowCommentBox(true)}
                    style={{flex:1, background:"#FACC15", border:"none", color:"#000", padding:"6px 0", borderRadius:"4px", cursor:"pointer"}}
                >
                    Add comment
                </button>
                </div>

                {/* ── comment dialog ── */}
                {showCommentBox && (
                <div style={{marginTop:"10px"}}>
                    <textarea
                    rows={3}
                    style={{width:"100%", borderRadius:"4px"}}
                    value={commentText}
                    onChange={e => setCommentText(e.target.value)}
                    placeholder="Write your note…"
                    />
                    <button
                    onClick={() => handleSaveComment("link" /* or "parcel" */)}
                    style={{marginTop:"6px", width:"100%", background:"#FFF", color:"#2563EB", border:"none", borderRadius:"4px", padding:"6px 0", cursor:"pointer"}}
                    >
                    Save comment
                    </button>
                </div>
                )}
            </div>
            )}

            {selectedParcelId && showParcels && (
                <div
                    style={{
                    position:"absolute", top:"10px", right:"10px", zIndex:3,
                    background:"#EC4899",   /* pink-500 */
                    color:"#FFF", padding:"12px 16px", borderRadius:"8px",
                    minWidth:"260px", boxShadow:"0 2px 8px rgba(0,0,0,.25)"
                    }}
                >
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <strong>Parcel</strong>
                    <button
                        onClick={() => setSelectedParcelId(null)}
                        style={{background:"transparent", border:"none", color:"#FFF",
                                cursor:"pointer", fontSize:"18px"}} aria-label="Close">
                        ✕
                    </button>
                    </div>

                    {populationMap[selectedParcelId] && (
                    <p style={{margin:"6px 0 12px"}}>
                        id: {selectedParcelId} <br/><br/>
                        Address:<br/>
                        {populationMap[selectedParcelId].street}, <br/>
                        {populationMap[selectedParcelId].city},&nbsp;
                        {populationMap[selectedParcelId].state}&nbsp;
                        {populationMap[selectedParcelId].zip} <br/><br/>
                        People: {populationMap[selectedParcelId].pop}

                    </p>
                    )}

                    <div style={{display:"flex", gap:"8px"}}>
                    <button
                        onClick={() => handleValidated("parcel")}
                        style={{flex:1, background:"#4ADE80", border:"none", color:"#000",
                                padding:"6px 0", borderRadius:"4px", cursor:"pointer"}}>
                        Looks good
                    </button>
                    <button
                        onClick={() => setShowCommentBox(true)}
                        style={{flex:1, background:"#FACC15", border:"none", color:"#000",
                                padding:"6px 0", borderRadius:"4px", cursor:"pointer"}}>
                        Add comment
                    </button>
                    </div>

                    {showCommentBox && (
                    <div style={{marginTop:"10px"}}>
                        <textarea
                        rows={3}
                        style={{width:"100%", borderRadius:"4px"}}
                        value={commentText}
                        onChange={e => setCommentText(e.target.value)}
                        placeholder="Write your note…"
                        />
                        <button
                        onClick={() => handleSaveComment("parcel")}
                        style={{marginTop:"6px", width:"100%", background:"#FFF",
                                color:"#EC4899", border:"none", borderRadius:"4px",
                                padding:"6px 0", cursor:"pointer"}}>
                        Save comment
                        </button>
                </div>
                )}
            </div>
            )}

            {selectedOtherId && (() => {
              const tk = tickets.find(t => t.id === selectedOtherId);
              if (!tk) return null;
              return (
                <div style={{
                  position: "absolute", top: "10px", right: "10px", zIndex: 3,
                  background: "#2563EB", color: "#FFF", padding: "12px 16px",
                  borderRadius: "8px", minWidth: "260px", boxShadow: "0 2px 8px rgba(0,0,0,.25)"
                }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <strong>Custom Ticket</strong>
                    <button onClick={() => setSelectedOtherId(null)}
                            style={{ background:"transparent", border:"none", color:"#FFF", cursor:"pointer", fontSize:"18px" }}>
                      ✕
                    </button>
                  </div>

                  <p style={{ margin:"6px 0 12px" }}>
                    {tk.address}<br/>
                    Comments:<br/>
                    {tk.comments_array?.map((c,i) =>
                      <div key={i} style={{ fontSize: "13px", marginBottom: "4px" }}>
                        – {c.text || c}
                      </div>
                    )}
                  </p>

                  <div style={{ display:"flex", gap:"8px" }}>
                    <button onClick={() => handleValidated("other")}
                            style={{ flex:1, background:"#4ADE80", border:"none", color:"#000", padding:"6px 0", borderRadius:"4px", cursor:"pointer" }}>
                      Looks good
                    </button>
                    <button onClick={() => setShowCommentBox(true)}
                            style={{ flex:1, background:"#FACC15", border:"none", color:"#000", padding:"6px 0", borderRadius:"4px", cursor:"pointer" }}>
                      Add comment
                    </button>
                  </div>

                  {showCommentBox && (
                    <div style={{ marginTop:"10px" }}>
                      <textarea
                        rows={3}
                        style={{ width:"100%", borderRadius:"4px" }}
                        value={commentText}
                        onChange={e => setCommentText(e.target.value)}
                        placeholder="Write your note…"
                      />
                      <button onClick={async () => {
                          if (!commentText.trim()) return setShowCommentBox(false);
                          await saveTicket(
                            "other",
                            selectedOtherId.replace(/^other_/, ''),
                            { lat: tk.latitude, lng: tk.longitude },
                            { text: commentText.trim(), ts: Timestamp.now().toMillis() },
                            "commented"
                          );
                          setCommentText("");
                          setShowCommentBox(false);
                        }}
                        style={{
                          marginTop:"6px", width:"100%", background:"#FFF",
                          color:"#2563EB", border:"none", borderRadius:"4px", padding:"6px 0", cursor:"pointer"
                        }}
                      >
                        Save comment
                      </button>
                    </div>
                  )}
                </div>
              );
            })()}


       <form
            onSubmit={async (e) => {
                e.preventDefault();
                const query = locationInput.trim();
                if (!query) return;
                try {
                const { lat, lng } = await geocodeAddress(query, "", "");   // helper already imported
                const map = mapRef.current;
                if (map && lat && lng)
                    modifyMapCamera(map, { lat: +lat, lng: +lng }, 18, 1000);
                } catch (err) { console.error("Geocode error:", err); }
            }}
            style={{ display: "flex", gap: "6px", marginBottom: "12px", marginTop: '10px' }}
            >
            <input
                type="text"
                value={locationInput}
                onChange={(e) => setLocationInput(e.target.value)}
                placeholder="Search location…"
                style={{
                flex: 1, padding: "6px 8px", borderRadius: "4px",
                border: "1px solid #444", background: "#3A3A3A", color: "#FFF"
                }}
            />
            <button
                type="submit"
                style={{
                padding: "6px 12px", background: "#2563EB", color: "#FFF",
                border: "none", borderRadius: "4px", cursor: "pointer"
                }}
            >
                Go
            </button>
            </form> 
          

      </div>  
  
      <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={DEFAULT_CENTER}
          zoom={DEFAULT_ZOOM}
          optio
          onLoad={(map) => { mapRef.current = map; }} // Store the map instance
          //options={{ styles: darkMapStyle }}
        >
          {isLoading && <div style={{ position: 'absolute', top: '50%', left: '50%' }}>Loading...</div>}
  

          {showAllNodes && Object.entries(nodeMap).map(([id, n]) => (
            <Circle
              key={`all-${id}`}
              center={{ lat: n.lat, lng: n.lng }}
              radius={16}
              options={{
                fillColor: '#1E90FF',          // bright blue
                fillOpacity: 0.7,
                strokeColor: 'black',
                strokeOpacity: 1,
                strokeWeight: 1,
              }}
              onClick={() => {console.log(id)}} 
            />
          ))}

        {showAllLinks && Object.entries(linkMap).map(([id, l]) => {
        let baseColor = "#006bff";                 // default light-blue
        const status  = ticketStatuses[`link_${id}`];
        if (status === "validated")  baseColor = "#1a9a7e";   // green-500
        if (status === "commented")  baseColor = "red";   // red-500

        return (
            <Polyline
            key={`all-${id}`}
            path={l.path}
            options={{
                strokeColor: selectedLinkId === id ? "orange" : baseColor,
                strokeOpacity: selectedLinkId === id ? 1 : 0.6,
                strokeWeight: selectedLinkId === id ? 6 : 4,
                icons: arrowSymbol(selectedLinkId === id ? "orange" : baseColor, selectedLinkId === id ? 4: 2.5),
                zIndex: selectedLinkId === id ? 1000 : 1
            }}
            onClick={() => handlePolylineClick(id)}
            />
        );
        })}
  
        {showParcels && Object.entries(populationMap).map(([pid, p]) => {
            let fillColor = "#00BFFF";                 // default pink
            const pStatus = ticketStatuses[`parcel_${pid}`];
            if (pStatus === "validated") fillColor = "#1a9a7e";
            if (pStatus === "commented") fillColor = "red";

            const circleColor = selectedParcelId === pid ? "orange" : fillColor

            return (
                <Circle
                key={pid}
                center={{ lat: p.lat, lng: p.lng }}
                radius={selectedParcelId === pid ? 15 : 5}
                options={{
                    fillColor: circleColor,
                    fillOpacity: selectedParcelId === pid ? 1 : 0.7,
                    strokeColor: "black",
                    strokeOpacity: 1,
                    strokeWeight: 1
                }}
                onClick={() => handleParcelClick(pid)}
                />
            );
        })}

        {otherTickets.map(tk => {
        const validated = tk.status === 'validated';

        return (
            <Marker
            key={tk.id}
            position={{ lat: tk.latitude, lng: tk.longitude }}
            icon={{
                url: SafetyIcon,
                scaledSize: new window.google.maps.Size(validated ? 50 : 50,
                                                        validated ? 50 : 50),
                anchor: new window.google.maps.Point(validated ? 18 : 18,
                                                    validated ? 18 : 18)
            }}
            opacity={validated ? 0.45 : 1}        // dim once validated
            onClick={() => {
                setShowCommentBox(false);
                setSelectedOtherId(tk.id);
                updateState({ focusTicket: tk });
                modifyMapCamera(
                mapRef.current,
                { lat: tk.latitude, lng: tk.longitude },
                18,
                600
                );
            }}
            />
        );
        })}

  
          
        </GoogleMap>
      </LoadScript>
    </div>
  );
}

export default ModelBuilderMapComponent;
